import { Col, Form, Radio, Row, Space } from "antd";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

const RadioUC = (props) => {
    const {
        name,
        label,
        disabled = false,
        showLabel = true,
        required,
        direction = 'vertical',
        children,
        labelSpan,
        value,
        handleChange,
        tooltipTitle = null,
        tooltipPlacement = 'topLeft'
    } = props;

    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{
                    required: true,
                    message: 'กรุณาเลือก ' + label
                }] : ''
                }
                valuePropName={value}
                tooltip={tooltipTitle ? {
                    title: tooltipTitle,
                    icon: <InfoCircleOutlined />,
                    placement: tooltipPlacement,
                    className: "label-Tooltip color-information"
                } : null}
            >
                <Radio.Group style={{ width: "100%" }} onChange={handleChange} value={value} disabled={disabled}>
                    <Space direction={direction} style={{ width: "100%" }}>
                        {children.map((item, index) => {
                            return (
                                <div key={index} className="w-full">
                                    <Row>
                                        <Col span={labelSpan} className='pr-3 '>
                                            <Radio value={item.value}>{item.title}</Radio>
                                        </Col>
                                        {item.child}
                                    </Row>
                                </div>
                            )
                        })}
                    </Space>
                </Radio.Group>
            </Form.Item >
        </>
    );
};

export default RadioUC;
